import type { EventPayload } from './types'

interface DataLayerWindow extends Window {
  dataLayer?: Array<Record<string, unknown>>
}

/**
 * Forward a widget event to the host page's `dataLayer` so the dealer's own
 * GA4 / Google Tag Manager container sees attributable chat activity. This is
 * the reason a marketing agency says yes to installing the tag.
 *
 * Events are namespaced `vyro.<name>` (e.g. `vyro.chat_opened`). Never throws.
 */
export function pushDataLayerEvent(win: Window, payload: EventPayload): void {
  if (!payload || typeof payload.name !== 'string' || !payload.name) return
  try {
    const target = win as DataLayerWindow
    if (!Array.isArray(target.dataLayer)) {
      target.dataLayer = []
    }
    target.dataLayer.push({
      event: `vyro.${payload.name}`,
      ...(payload.data ?? {}),
    })
  } catch {
    // dataLayer forwarding is best-effort; never break the host page.
  }
}
